import { render, staticRenderFns } from "./home-caption1.vue?vue&type=template&id=2cb61eb6&"
import script from "./home-caption1.vue?vue&type=script&lang=js&"
export * from "./home-caption1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports